import React from "react";
import { FaSpinner } from "react-icons/fa";
import { useMutation } from "@apollo/client";
import { ARCHIVE_NOTIFICATIONS } from "../../../screens/Notification/queries";
import { ActionButton } from "./styles";
import renderStatusModal from "../../../components/Forms/renderStatusModal";

export const ArchiveButton = ({
  show,
  data,
  refetch,
  setCheckedCases,
  clearCheckAll,
  forceRefetch,
}) => {
  const handleClick = () => {
    archiveNotifications({ variables: { Notifications: data } });
  };
  const [archiveNotifications, { loading }] = useMutation(
    ARCHIVE_NOTIFICATIONS,
    {
      onCompleted() {
        renderStatusModal(true, "Successfully archived notifications.");
        setCheckedCases([]);
        clearCheckAll(false);
        forceRefetch();
        refetch();
      },
      onError() {
        setCheckedCases([]);
        clearCheckAll(false);
        renderStatusModal(false, "Could not archive notifications.");
      },
    }
  );

  return show === "Active" ? (
    <ActionButton disabled={!data.length} onClick={handleClick}>
      Archive Selected ({data.length}){" "}
      {loading && <FaSpinner className="icon-spin" />}
    </ActionButton>
  ) : null;
};
